import React from 'react';

export function UploadIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" fill="none">
            <path d="M8 11.2V2.6M8 2.6 5.3 5.3M8 2.6l2.7 2.7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 11.2V13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
    );
}

export function SearchIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" fill="none">
            <circle cx="7" cy="7" r="4.2" stroke="currentColor" strokeWidth="1.4" />
            <path d="M10.2 10.2 13 13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
    );
}

export function FilterIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" fill="none">
            <path d="M2.2 3.5h11.6M4.2 8h7.6M6.4 12.5h3.2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
    );
}
